(function (window, document, $) {
  'use strict';

  function initSelect2(context = document) {
    if (!$ || !$.fn.select2) return;

    $(context)
      .find('.select2')
      .not('.select2-hidden-accessible')
      .select2({
        placeholder: 'Select an option',
        allowClear: true,
        closeOnSelect: false,
        width: '100%'
      });
  }

  // GLOBAL helper — reusable everywhere
  window.reInitSelect2 = function (el) {
    if (!$ || !$.fn.select2) return;

    const $el = $(el);

    if ($el.hasClass('select2-hidden-accessible')) {
      $el.select2('destroy');
    }

    $el.select2({
      placeholder: 'Select an option',
      allowClear: true,
      closeOnSelect: false,
      width: '100%'
    });
  };

  document.addEventListener('DOMContentLoaded', () => initSelect2());
  document.addEventListener('shopify:section:load', (e) => initSelect2(e.target));

})(window, document, window.jQuery);
